import { render, staticRenderFns } from "./imageText.vue?vue&type=template&id=43681a19&scoped=true&"
import script from "./imageText.vue?vue&type=script&lang=js&"
export * from "./imageText.vue?vue&type=script&lang=js&"
import style0 from "./imageText.vue?vue&type=style&index=0&id=43681a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43681a19",
  null
  
)

export default component.exports